const SITE_URL = "https://kurpfalz-automation.de";
const LOGO_URL = `${SITE_URL}/logo-kurpfalz-automation.png`;

const SERVICE_AREA_CITIES = [
  "Heddesheim",
  "Mannheim",
  "Heidelberg",
  "Ludwigshafen am Rhein",
  "Weinheim",
  "Viernheim",
  "Schwetzingen",
  "Speyer",
  "Frankenthal",
];

export const ORGANIZATION_ID = `${SITE_URL}/#organization`;

// Single source of truth for the business' JSON-LD identity, referenced
// via @id from every page's LocalBusiness/Service/FAQPage/BlogPosting schema.
export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": ORGANIZATION_ID,
  name: "Kurpfalz Automation",
  alternateName: "CK & Partners",
  description:
    "Automatisierung von Terminplanung, Lead-Erfassung und Kundenkommunikation für Handwerksbetriebe, Praxen, Immobilienverwalter und Industrie in der Rhein-Neckar-Region.",
  url: `${SITE_URL}/`,
  image: LOGO_URL,
  logo: LOGO_URL,
  address: {
    "@type": "PostalAddress",
    streetAddress: "Oberdorfstr. 25",
    postalCode: "68542",
    addressLocality: "Heddesheim",
    addressRegion: "Baden-Württemberg",
    addressCountry: "DE",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 49.4674,
    longitude: 8.6333,
  },
  areaServed: SERVICE_AREA_CITIES.map((name) => ({ "@type": "City", name })),
  sameAs: [
    "https://www.facebook.com/profile.php?id=61592485093048",
    "https://www.instagram.com/kurpfalzautomation",
  ],
  priceRange: "€€",
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const faqPageSchema = (faqItems) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
});

export const offerCatalogSchema = (serviceList) => ({
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  name: "Automatisierungs-Leistungen von Kurpfalz Automation",
  itemListElement: serviceList.map((s, i) => ({
    "@type": "Offer",
    position: i + 1,
    itemOffered: {
      "@type": "Service",
      name: s.title,
      description: s.text,
      provider: { "@id": ORGANIZATION_ID },
      areaServed: { "@type": "Place", name: "Rhein-Neckar-Region" },
    },
  })),
});

export const serviceSchema = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE_URL}${path}`,
  provider: { "@id": ORGANIZATION_ID },
  areaServed: { "@type": "Place", name: "Rhein-Neckar-Region" },
});

export const blogPostingSchema = ({ title, description, path, datePublished }) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: title,
  description,
  url: `${SITE_URL}${path}`,
  datePublished,
  dateModified: datePublished,
  inLanguage: "de-DE",
  author: { "@id": ORGANIZATION_ID },
  publisher: { "@id": ORGANIZATION_ID },
  mainEntityOfPage: `${SITE_URL}${path}`,
});

export { SITE_URL, LOGO_URL, SERVICE_AREA_CITIES };
